import React, { useState, createContext } from "react";
import { IAddAssetForm, IAddAssetFormValidation } from "../../interfaces/interface";

export const AddAssetContext = createContext<any>({});

export const AddAssetProvider: React.FC = (props) => {
    const [formInput, setFormInput] = useState<IAddAssetForm>({
        assetName: "",
        deviceId: "",
        assetType: "",
        assetDescription: "",
        profile:"",
        state: ""
      });
    const [formFieldsValid, setFormFieldsValid] = useState<IAddAssetFormValidation>({
    assetName: {
      isValid: false,
      displayMessage: false,
      message: ""
    },
    deviceId: {
      isValid: false,
      displayMessage: false,
      message: ""
    },
    assetType: {
      isValid: false,
      displayMessage: false,
      message: ""
    },
    assetDescription: {
      isValid: true,
      displayMessage: false,
      message: ""
    }
    });
    const [defaultSelectValue, setDefaultSelectValue] = useState<string>("");
    const [selectValue, setSelectValue] = useState<string>("");
    const [errorMessage, setErrorMessage] = useState<string>("")

  return (
    <AddAssetContext.Provider
      value={{
        aAForm: [formInput, setFormInput],
        formVal: [formFieldsValid, setFormFieldsValid],
        defaultValueSelect: [defaultSelectValue, setDefaultSelectValue],
        valueSelect: [selectValue, setSelectValue],
        errMessage: [errorMessage, setErrorMessage]
      }}
    >
      {props.children}
    </AddAssetContext.Provider>
  );
};
